import React, {useState, useEffect, useRef} from 'react';
import {Switch, Route, Redirect, generatePath} from 'react-router-dom';
import {useDataValue} from 'globals/contexts/dataContext';
import routes from 'globals/routes';
// import logo from './logo.svg';
import ScrollToTop from 'components/scrollToTop';

import scrollingTo from 'utils/scrollingTo';

import IndexPage from 'pages/indexPage';
import TestPage from 'pages/testPage';
import PrivacyPage from 'pages/privacyPage';
import LegalPage from 'pages/legalPage';
import CommercialPage from 'pages/commercialPage';
import CommercialProjectPage from 'pages/commercialProjectPage';
import ProjectPage from 'pages/projectDetailPage';
import ArtPage from 'pages/artPage';
import ArtShowcasePage from 'pages/artShowcasePage';
import AboutPage from 'pages/aboutPage';
import ExperiencePage from 'pages/experiencePage';
import EventPage from 'pages/eventPage';
import ContactPage from 'pages/contactPage';

import Switcher from 'containers/switcher';
import Menu from 'containers/menu';
import InkTransition from 'components/inkTransition';

import './App.css';

const templates = {
  indexPage: IndexPage,
  testPage: TestPage,
  privacyPage: PrivacyPage,
  legalPage: LegalPage,
  commercialPage: CommercialPage,
  commercialProjectPage: CommercialProjectPage,
  projectPage: ProjectPage,
  artPage: ArtPage,
  artShowcasePage: ArtShowcasePage,
  aboutPage: AboutPage,
  experiencePage: ExperiencePage,
  eventPage: EventPage,
  contactPage: ContactPage,
};
// for ssr, maybe not use loadable in this project
const getRenderPropForRoute = (pageId) => {
  // const AppComponent = asyncLoadingPage(pageId);
  const AppComponent = templates[pageId];
  return (match) => { return (<AppComponent match={match} />) };
  
}

const App = () => {
  const [scrollOffset, setScrollOffset] = useState([0,0]); 
  const [{content, menuIsActive, currentLanguage, currentPage, pageTransition}, dispatch] = useDataValue();
  const scrollThreshold = 50;
  const updateScrollOffset = () => {
    setScrollOffset([window.scrollX, window.scrollY]);
  }
  const prevPage = useRef('');

  useEffect(() => {
    window.addEventListener("scroll", updateScrollOffset);
    return () => {
      window.removeEventListener("scroll", updateScrollOffset);
    }
  }, []);
  useEffect(() => {
    if (scrollOffset[1] > scrollThreshold) {
      document.documentElement.classList.add("scrolled");
    } else {
      document.documentElement.classList.remove("scrolled");
    }
  }, [scrollOffset]);
  useEffect(() => {
    const currentScrollOffset = scrollOffset;
    if (menuIsActive) {
      document.documentElement.classList.add("menuOpen");
    } else {
      document.documentElement.classList.remove("menuOpen");
    }
    return () => {
      if (menuIsActive) {
        window.scrollTo(currentScrollOffset[0], currentScrollOffset[1]);
      }
    }
  }, [menuIsActive]);
  return (
    <Route path="/:lang?/:page?/:params1?" render={(match) => {
      const allLanguages = content['language'].map(lang => lang['code']);
      const userLanguage = match['match']['params']['lang'];
      const userPage = match['match']['params']['page'];
      if (allLanguages.includes(userLanguage)) {
        if (currentLanguage !== userLanguage) {
          dispatch({
            type: 'setCurrentLanguage',
            data: userLanguage
          });
        }
        if (userLanguage && currentPage !== userPage) {
          dispatch({
            type: 'setCurrentPage',
            data: userPage
          });
        }
        if (pageTransition || prevPage.current === '') {
          setTimeout(() => {
            prevPage.current = currentPage;
          }, 500);
        }
        return <div id="app">
          {/* <div id="logo" onClick={() => scrollingTo(0, 0)}><img src={content['logo']} /></div> */}
          <div id="contentWrapper">
            <ScrollToTop />
            <Switch>
              <Route path={routes.indexPage} render={pageTransition? getRenderPropForRoute(`${prevPage.current}Page`) : getRenderPropForRoute('indexPage')} />
              <Route path={routes.privacyPage} render={pageTransition? getRenderPropForRoute(`${prevPage.current}Page`) : getRenderPropForRoute('privacyPage')} />
              <Route path={routes.legalPage} render={pageTransition? getRenderPropForRoute(`${prevPage.current}Page`) : getRenderPropForRoute('legalPage')} />
              <Route path={routes.commercialPage} render={pageTransition? getRenderPropForRoute(`${prevPage.current}Page`) : getRenderPropForRoute('commercialPage')} />
              <Route path={routes.commercialProjectPage} render={pageTransition? getRenderPropForRoute(`${prevPage.current}Page`) : getRenderPropForRoute('commercialProjectPage')} />
              <Route path={routes.projectPage} render={pageTransition? getRenderPropForRoute(`${prevPage.current}Page`) : getRenderPropForRoute('projectPage')} />
              <Route path={routes.artShowcasePage} render={pageTransition? getRenderPropForRoute(`${prevPage.current}Page`) : getRenderPropForRoute('artShowcasePage')} />
              <Route path={routes.artPage} render={pageTransition? getRenderPropForRoute(`${prevPage.current}Page`) : getRenderPropForRoute('artPage')} />
              <Route path={routes.aboutPage} render={pageTransition? getRenderPropForRoute(`${prevPage.current}Page`) : getRenderPropForRoute('aboutPage')} />
              <Route path={routes.experiencePage} render={pageTransition? getRenderPropForRoute(`${prevPage.current}Page`) : getRenderPropForRoute('experiencePage')} />
              <Route path={routes.eventPage} render={pageTransition? getRenderPropForRoute(`${prevPage.current}Page`) : getRenderPropForRoute('eventPage')} />
              <Route path={routes.testPage} render={pageTransition? getRenderPropForRoute(`${prevPage.current}Page`) : getRenderPropForRoute('testPage')} />
              <Route path={routes.contactPage} render={pageTransition? getRenderPropForRoute(`${prevPage.current}Page`) : getRenderPropForRoute('contactPage')} />
              <Redirect to={generatePath(routes.indexPage, {lang: userLanguage})} />
            </Switch>
          </div>
          <Menu />
          <Switcher />
          <InkTransition />
        </div>;
      } else {
        return <Redirect to={generatePath(routes.indexPage, {lang: currentLanguage})} />;
      }
    }} />
  );
}

export default App;
